__turbopack_context__.v({
  "hidden": "SupportingText-module-scss-module__EFvtqW__hidden",
  "secondary_text": "SupportingText-module-scss-module__EFvtqW__secondary_text",
  "supporting_text": "SupportingText-module-scss-module__EFvtqW__supporting_text",
  "title": "SupportingText-module-scss-module__EFvtqW__title",
  "toggle_button": "SupportingText-module-scss-module__EFvtqW__toggle_button",
});
